import styled from 'styled-components';
import { Layout } from '@oneaudi/unified-web-components';

export const DealerDetailStyled = styled.div`
  display: flex;
  margin: 0 0 ${({ theme }): string => theme.spacing.l}; //0 0 var(--one-header-space-l);
`;

export const StyledLayout = styled(Layout)`
  display: flex;
  flex-direction: column;
  align-self: center;
  flex: 0 1 auto;

  &.icon {
    margin-right: ${({ theme }): string => theme.spacing.m};
    color: ${({ theme }): string => (theme.type === 'legacy' ? '' : theme.colors.icon)};
  }
`;

export const OpenHoursStyled = styled.div`
  display: flex;
  align-items: center;

  .badge {
    margin-right: ${({ theme }): string => theme.spacing.m};
  }
`;

export const DealerTelStyled = styled.div`
  cursor: pointer;
`;
